import { Modal } from '@distribusion/owl-frontend-ui'
import { useFormikContext } from 'formik'
import React, { ReactElement } from 'react'

import Loader from '@components/Loader'
import { POPUP_TYPES } from '@constants/popupTypes'
import { useModalFocusTrap } from '@hooks/useModalFocusTrap'
import { usePopupAnalytics } from '@hooks/usePopupAnalytics'
import paymentInProcessIcon from '@images/checkout/paymentInProcess.svg'
import bem from '@lib/bem'
import { useTranslation } from '@lib/i18n'
import { CheckoutFormData } from '@pages/Checkout/hooks/useInitialFormValues'

import '@pages/Checkout/Payment/InProgressModal/index.scss'

interface PaymentInProgressModalProps {
  opened: boolean
}

const RESERVATION_MESSAGE_METHODS = ['hold_reservation', 'cash', 'terminal', 'invoice']

const PaymentInProgressModal = ({ opened }: PaymentInProgressModalProps): ReactElement => {
  const { t } = useTranslation()
  const context = useFormikContext<CheckoutFormData>()
  const paymentMethod = context?.values?.paymentMethod

  const isReservationInProgress = paymentMethod != null && RESERVATION_MESSAGE_METHODS.includes(paymentMethod)
  const translationScope = isReservationInProgress ? 'checkout.reservationInProcess' : 'checkout.paymentInProcess'

  usePopupAnalytics(POPUP_TYPES.PAYMENT_IN_PROGRESS, 'checkout', opened)

  /* istanbul ignore next */
  const modalRef = useModalFocusTrap({
    isOpen: opened,
  })

  return (
    <Modal
      opened={opened}
      className="payment-in-progress"
      labelledbyId="payment_label_title"
      data-tag="payment-modal-progress"
      describedbyId="description_payment_process"
    >
      <div ref={modalRef} className="column gap-3 items-center" tabIndex={-1}>
        <div className="payment-in-progress__image-container">
          <img
            src={paymentInProcessIcon}
            className={bem('payment-in-progress', 'icon')}
            alt={t('accessibility.images.paymentProcessingIcon')}
          />
          <Loader aria-hidden="true" loading={true} className="payment-in-progress__spinner" color="white" />
        </div>
        <h3 id="payment_label_title" className={bem('payment-in-progress', 'title')}>
          {t(`${translationScope}.title`)}
        </h3>
        <div id="description_payment_process">{t(`${translationScope}.description`)}</div>
      </div>
    </Modal>
  )
}

export default PaymentInProgressModal
